import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    timeoutSeconds: Number,
    signedId: String
  }

  initialize() {
    this.autoSnooze = this.autoSnooze.bind(this)
  }

  connect() {
    this.timer = setTimeout(this.autoSnooze, this.timeoutSecondsValue * 1000)
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  async autoSnooze() {
    try {
      const csrfToken = document.querySelector("[name='csrf-token']").content

      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          signed_id: this.signedIdValue
        })
      })

      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      window.location.reload()
    } catch (error) {
      console.error("Auto-snooze request failed:", error)
      window.location.reload()
    }
  }
}
